import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { UserChatCrm } from 'src/app/interfaces/userchatcrm';
import { LoginService } from 'src/app/service/login.service';
import { UsersService } from 'src/app/service/users.service';

@Component({
  selector: 'app-changpassword',
  templateUrl: './changpassword.component.html',
  styleUrls: ['./changpassword.component.scss'],
  providers: [MessageService]
})

export class ChangpasswordComponent implements OnInit {
  @Output() passwordRestoreChanged = new EventEmitter<boolean>();
  password: string = '';
  confirmPassword: string = '';
  usuario: UserChatCrm
  mensajeError: string = ''
  showError: boolean = false;
  passwordRestore: boolean | undefined

  constructor(
    private messageService: MessageService,
    private userService: UsersService,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.usuario = this.loginService.chatCrmUser
    this.passwordRestore = loginService.chatCrmUser.passwordRestore
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  addSingle() {
    this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: this.translate.instant('PASSWORD_UPDATED') });
  }

  updatePassword() {
    if (this.password === this.confirmPassword) {
      this.userService.updatePassword(this.usuario.id, this.password).pipe(
        catchError((error) => {
          return throwError(error);
        })
      ).subscribe((result) => {
        this.addSingle();
        this.loginService.ingresarUsuario({ ...this.usuario, passwordRestore: false });
        this.password = "";
        this.confirmPassword = "";
        
      });
      this.showError = false;
    } else {
      this.mensajeError = this.translate.instant('PASSWORD_NOT_MATCH');
      this.showError = true;
    }
  }
  

}
